import { YieldType } from "../globalTypes";
import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import {
  ASK_IDX,
  BID_IDX,
  DATA_PRODUCER_TABLE_NAME,
  DEFAULT_BUTTON_TO_RETRY_TEXT,
  ERROR_SENDING_DATA_FILL_COLOR,
  ERROR_SENDING_DATA_FONT_COLOR,
  UPDATE_BUTTON_IDX,
} from "./constants";

interface SetErrorInSpecificYieldArgs {
  yieldType: YieldType;
  sentRow: number;
  setButtonToRetry?: boolean;
}

const setCellErrorFormat = (cell: Excel.Range) => {
  cell.format.fill.color = ERROR_SENDING_DATA_FILL_COLOR;
  cell.format.font.color = ERROR_SENDING_DATA_FONT_COLOR;
};

export const setErrorInSpecificYield = async ({
  yieldType,
  sentRow,
  setButtonToRetry = true,
}: SetErrorInSpecificYieldArgs) => {
  await Excel.run(async (context) => {
    const worksheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);
    const table = worksheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);

    const yieldIndex = yieldType === YieldType.BID ? BID_IDX : ASK_IDX;
    const yieldCell = table.columns.getItemAt(yieldIndex).getRange().getCell(sentRow, 0);

    setCellErrorFormat(yieldCell);

    await context.sync();

    if (!setButtonToRetry) return;

    const actionButton = table.columns.getItemAt(UPDATE_BUTTON_IDX).getRange().getCell(sentRow, 0);

    setCellErrorFormat(actionButton);
    actionButton.values = [[DEFAULT_BUTTON_TO_RETRY_TEXT]];

    await context.sync();
  });
};
